import axios from "axios";
import { useEffect, useState } from "react";
import { useBrandingContext } from "../../../../../../../components/BrandingContext";

export const useFetchData = ({ roomId }) => {
  const [branding, setBranding] = useState({ roomNameColor: "#443d80" });
  const { branding: ctxBranding } = useBrandingContext();
  const [avgRating, setAvgRating] = useState(0);

  useEffect(() => {
    const fetchRating = async () => {
      try {
        if (roomId) {
          const response = await axios.get(`/api/rooms/review/${roomId}`);
          setAvgRating(response.data.avgRating);
        }
      } catch (error) {
        console.error("Error fetching room rating:", error);
      }
    };

    fetchRating();
  }, [roomId]);

  useEffect(() => {
    if (ctxBranding) {
      try {
        const prev = JSON.stringify(branding || {});
        const next = JSON.stringify(ctxBranding || {});
        if (prev !== next) setBranding(ctxBranding);
      } catch (err) {
        setBranding(ctxBranding);
      }
    }
  }, [ctxBranding]);

  return {
    branding,
    avgRating,
    setAvgRating,
  };
};
